import React from 'react';
import cn from 'classnames';
import { reduxForm, Field } from 'redux-form';
import SelectField from './SelectField';
import FormError from './FormError';
import { formatSaveStatus } from '../helpers/formatters';
import CheckboxField from './CheckboxField';
import { planCarriersDisplayNames } from 'constants/attCarriers';
import { getSubStatus } from 'helpers/subs';

const getPlanCarriers = (plans) => {
  if (!plans) {
    return [];
  }

  const planCarriers = Array.from(
    new Set(plans.map((plan) => plan.plan_carrier)),
  );
  return planCarriers.map((carrier) => [
    carrier,
    planCarriersDisplayNames[carrier]
      ? planCarriersDisplayNames[carrier]
      : carrier,
  ]);
};

const getGroupedPlanTitles = (plans) => {
  if (!plans) {
    return [];
  }

  const planTitles = Array.from(new Set(plans.map((plan) => plan.name)));
  return planTitles.map((title) => [title, title]);
};

const getPlanPrices = (plans, name) => {
  if (!plans || !name) {
    return [];
  }

  const planPrices = plans
    .filter((plan) => plan.name === name)
    .map((plan) => [plan.price, plan.price]);
  return planPrices;
};

const getPlanByTitleAndPrice = (plans, name, price, plan_carrier) => {
  if (plan_carrier) {
    return plans.find(
      (plan) =>
        plan.name === name &&
        plan.price === price &&
        plan.plan_carrier === plan_carrier,
    );
  }
  return plans.find((plan) => plan.name === name && plan.price === price);
};

const transformValues = (plans, values) => {
  const { plan_name, plan_price, plan_carrier, ...restValues } = values;
  if (!plan_name || !plan_price) {
    return { ...restValues, plan_id: null };
  }
  const plan = getPlanByTitleAndPrice(
    plans,
    plan_name,
    plan_price,
    plan_carrier,
  );
  return { ...restValues, plan_id: plan.id };
};

class SplitedPlanForm extends React.Component {
  composeSubmit = (e) => {
    const { handleSubmit, onSubmit, showCarrierDropdown, plans, planCarrier } =
      this.props;

    e.preventDefault();

    const filteredPlans =
      showCarrierDropdown && planCarrier
        ? plans.filter((plan) => plan.plan_carrier === planCarrier)
        : plans;

    return handleSubmit((values) =>
      onSubmit(transformValues(filteredPlans, values)),
    )(e);
  };

  render() {
    const {
      planName,
      error,
      saveStatus,
      upgradePlanLink,
      plans,
      subId,
      sub,
      SubNav,
      heading,
      requestedPlan,
      showForce,
      showLockCheckbox,
      planCarrier,
      showCarrierDropdown,
      showResetButton,
      resetAttFormValues,
      refs,
      isModal,
      isQuick,
      isBusiness,
    } = this.props;

    const filteredPlans =
      showCarrierDropdown && planCarrier
        ? plans.filter((plan) => plan.plan_carrier === planCarrier)
        : plans;
    const planNameOptions = getGroupedPlanTitles(filteredPlans);
    const planPriceOptions = getPlanPrices(filteredPlans, planName);

    return (
      <div ref={refs}>
        {!isModal && (
          <React.Fragment>
            <h1>{heading}</h1>
            <SubNav />
          </React.Fragment>
        )}

        {requestedPlan ? <p>User has requested {requestedPlan} plan.</p> : ''}
        <form onSubmit={this.composeSubmit}>
          {showCarrierDropdown && (
            <Field
              component={SelectField}
              name="plan_carrier"
              label="Plan Carrier"
              empty="None"
              options={getPlanCarriers(plans)}
            />
          )}
          {(!showCarrierDropdown || (showCarrierDropdown && planCarrier)) && (
            <Field
              component={SelectField}
              name="plan_name"
              label="Plan Name"
              empty="None"
              options={planNameOptions}
            />
          )}
          {planName && (
            <Field
              component={SelectField}
              name="plan_price"
              label="Plan Price"
              empty="None"
              options={planPriceOptions}
            />
          )}
          {showLockCheckbox && (
            <Field
              component={CheckboxField}
              name="plan_lock"
              label="Lock plan"
            />
          )}
          {showForce && (
            <Field component={CheckboxField} name="force" label="Force" />
          )}
          {error &&
            (upgradePlanLink && !isBusiness && !isQuick ? (
              <React.Fragment>
                <FormError error={error} />
                <div>
                  To upgrade the current plan go here. —{' '}
                  <a href={upgradePlanLink(subId)}>Go here</a>
                </div>
              </React.Fragment>
            ) : (
              <FormError error={error} />
            ))}
          <br />
          <button
            className={cn({
              btn: true,
              'btn-default': !isModal,
              'btn-primary': isModal,
            })}
            disabled={saveStatus === 'PENDING'}
          >
            Save Plan
          </button>
          {showResetButton && sub && getSubStatus(sub) === 'new' && (
            <button
              className="btn btn-default mar-l"
              type="button"
              onClick={resetAttFormValues}
            >
              Reset Form
            </button>
          )}
          <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
        </form>
      </div>
    );
  }
}

const validate = (values, { isQuick }) => {
  let errors = {};

  // if (props.showCarrierDropdown && !values.plan_carrier) {
  //   errors.plan_carrier = 'Required';
  // }

  if (isQuick) {
    if (values.plan_name && !values.plan_price) {
      errors.plan_price = 'Required';
    }
  } else {
    if (!values.plan_name) {
      errors.plan_name = 'Required';
    }

    if (!values.plan_price) {
      errors.plan_price = 'Required';
    }
  }

  return errors;
};

SplitedPlanForm = reduxForm({
  form: 'plan',
  enableReinitialize: true,
  validate,
})(SplitedPlanForm);

export default SplitedPlanForm;
